
import { defineComponent } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
    props: {
        section: {
            type: String,
            required: true
        }
    },

    setup() {
        const store = useStore();

        function changeScreen() {
            store.dispatch('axn_updateEhrActiveFrame', 'epic-statistical-methods');
        }

        return { changeScreen }
    }
})

